import styled from 'styled-components';
import Link from 'next/link';
import { shouldRenderWorldlineDashboard, shouldRenderDemoDashboard } from '@algoan/dashboard/utils';
import { DashboardLogo } from './dashboard-logo';
import { DemoLogo } from '../icons';
import { addAlpha } from '@algoan/deep-dive/theme';

export const HeaderLogo: React.FC = () => {
  const showWorldlineDashboard = shouldRenderWorldlineDashboard();
  const showDemoDashboard = shouldRenderDemoDashboard();

  if (showWorldlineDashboard) {
    return (
      <Link href="/" passHref legacyBehavior>
        <S.SubContainer>
          <S.WorldlineLogoContainer>
            <S.WorldlineLogo src="/images/icons/worldline-logo.png" alt="logo" />
          </S.WorldlineLogoContainer>
          <S.AlgoanLogoContainer>
            <DashboardLogo size="small" />
          </S.AlgoanLogoContainer>
        </S.SubContainer>
      </Link>
    );
  } else if (showDemoDashboard) {
    return (
      <Link href="/" passHref legacyBehavior>
        <S.DemoLogoContainer>
          <DashboardLogo />
          <S.DemoWrapper>
            <DemoLogo />
          </S.DemoWrapper>
        </S.DemoLogoContainer>
      </Link>
    );
  } else {
    return (
      <Link href="/" passHref legacyBehavior>
        <S.LogoContainer>
          <DashboardLogo />
        </S.LogoContainer>
      </Link>
    );
  }
};

const S = {
  SubContainer: styled.a`
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding-right: 24px;
  `,
  WorldlineLogoContainer: styled.div`
    position: relative;
    display: flex;
    align-items: center;
  `,
  WorldlineLogo: styled.img`
    width: 130px;
    height: 21px;
  `,
  AlgoanLogoContainer: styled.div`
    position: relative;
  `,
  LogoContainer: styled.a`
    position: relative;
  `,
  DemoLogoContainer: styled.a`
    display: flex;
    position: relative;
  `,
  DemoWrapper: styled.div`
    border-left: 1px solid ${({ theme }) => addAlpha(theme.extraColors.deepGrey, 0.1)};
    margin-left: 26px;
    padding-left: 22px;
    padding-top: 3px;
  `,
};
